
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_16248_48sij_13",
  "icon": "awsui_icon_16248_48sij_45",
  "header-inner": "awsui_header-inner_16248_48sij_61",
  "disabled": "awsui_disabled_16248_48sij_70",
  "header": "awsui_header_16248_48sij_61",
  "body": "awsui_body_16248_48sij_73",
  "header-row": "awsui_header-row_16248_48sij_77",
  "description": "awsui_description_16248_48sij_90",
  "has-header": "awsui_has-header_16248_48sij_96",
  "header-button": "awsui_header-button_16248_48sij_110",
  "overlay-button": "awsui_overlay-button_16248_48sij_111",
  "variant-embedded": "awsui_variant-embedded_16248_48sij_130",
  "variant-default": "awsui_variant-default_16248_48sij_142",
  "inner-card": "awsui_inner-card_16248_48sij_243",
  "no-padding": "awsui_no-padding_16248_48sij_250",
  "icon-vertical-align-center": "awsui_icon-vertical-align-center_16248_48sij_261",
  "icon-align-end": "awsui_icon-align-end_16248_48sij_397"
};
  